import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1n9qg6fb0b5i8 as toString,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataOutputEncoderClass;
function DataOutputEncoder() {
  if (DataOutputEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor($outer, output) {
        return new.target.new_com_lightningkite_services_data_StringArrayFormat_DataOutputEncoder_e9alge_k$($outer, output);
      }
      static new_com_lightningkite_services_data_StringArrayFormat_DataOutputEncoder_e9alge_k$($outer, output, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
        $this.output_1 = output;
        $this.lastMarkerWritten_1 = -1;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.$this_1.serializersModule_1;
      }
      encodeBoolean_tu2e59_k$(value) {
        this.output_1(value.toString());
      }
      encodeByte_6txfee_k$(value) {
        this.output_1(value.toString());
      }
      encodeShort_gza6si_k$(value) {
        this.output_1(value.toString());
      }
      encodeInt_y5zi3z_k$(value) {
        this.output_1(value.toString());
      }
      encodeLong_vlw3uq_k$(value) {
        this.output_1(value.toString());
      }
      encodeFloat_b8b85a_k$(value) {
        this.output_1(value.toString());
      }
      encodeDouble_n270q9_k$(value) {
        this.output_1(value.toString());
      }
      encodeChar_id8ngf_k$(value) {
        this.output_1(toString(value));
      }
      encodeString_424b5v_k$(value) {
        this.output_1(value);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        this.output_1(enumDescriptor.getElementName_u4sqmf_k$(index));
      }
      beginCollection_9edss2_k$(descriptor, collectionSize) {
        this.encodeInt_y5zi3z_k$(collectionSize);
        return DataOutputEncoder().new_com_lightningkite_services_data_StringArrayFormat_DataOutputEncoder_e9alge_k$(this.$this_1, this.output_1);
      }
      beginStructure_yljocp_k$(descriptor) {
        return DataOutputEncoder().new_com_lightningkite_services_data_StringArrayFormat_DataOutputEncoder_e9alge_k$(this.$this_1, this.output_1);
      }
      encodeNull_ejiosz_k$() {
        return this.encodeBoolean_tu2e59_k$(false);
      }
      encodeNotNullMark_415a1t_k$() {
        return this.encodeBoolean_tu2e59_k$(true);
      }
      encodeElement_5v7eyb_k$(descriptor, index) {
        if (equals(descriptor.get_kind_wop7ml_k$(), CLASS_getInstance())) {
          if (index === (this.lastMarkerWritten_1 + 1 | 0) && !descriptor.isElementOptional_heqq56_k$(index)) {
            this.lastMarkerWritten_1 = index;
          } else {
            this.output_1(descriptor.getElementName_u4sqmf_k$(index));
            this.lastMarkerWritten_1 = index;
          }
        }
        return true;
      }
      endStructure_1xqz0n_k$(descriptor) {
        if (equals(descriptor.get_kind_wop7ml_k$(), CLASS_getInstance()) && !(this.lastMarkerWritten_1 === (descriptor.get_elementsCount_288r0x_k$() - 1 | 0))) {
          if (descriptor.get_elementsCount_288r0x_k$() >= 254) {
            this.output_1('end');
          }
        }
      }
    }
    initMetadataForClass($, 'DataOutputEncoder');
    DataOutputEncoderClass = $;
  }
  return DataOutputEncoderClass;
}
var StringArrayFormatClass;
function StringArrayFormat() {
  if (StringArrayFormatClass === VOID) {
    class $ {
      constructor(serializersModule) {
        this.serializersModule_1 = serializersModule;
      }
      encodeToString_k0apqx_k$(serializer, value) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        var $this$buildString = this_0;
        var first = {_v: true};
        DataOutputEncoder().new_com_lightningkite_services_data_StringArrayFormat_DataOutputEncoder_e9alge_k$(this, (it) => {
          if (first._v) {
            first._v = false;
          } else
            $this$buildString.append_58al37_k$(_Char___init__impl__6a9atx(44));
          $this$buildString.append_22ad7x_k$(replace(replace(it, '\\', '\\\\'), ',', '\\,'));
          return Unit_instance;
        }).encodeSerializableValue_3uuzip_k$(serializer, value);
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'StringArrayFormat');
    StringArrayFormatClass = $;
  }
  return StringArrayFormatClass;
}
//region block: exports
export {
  StringArrayFormat as StringArrayFormat1xi667mcf8p4h,
};
//endregion

//# sourceMappingURL=StringArrayFormat.mjs.map
